import { forwardRef } from 'react';
import { Badge, LinkBaseProps } from '@mui/material';
import { useAlerts } from 'contexts/alertsContext';
import { AlertsContextState } from 'contexts/alertsContext/alertsContext.types';
import { Link, To } from 'react-router-dom';

export const createBadgeTab = (
  to: To,
  alertsContextKey?: Exclude<keyof AlertsContextState, 'alertsInbox'>,
) =>
  forwardRef<HTMLAnchorElement, LinkBaseProps>(function MenuTab(props, ref) {
    const { state } = useAlerts();

    const { children, ...linkProps } = props;

    return (
      <Link {...linkProps} ref={ref} to={to}>
        <Badge
          badgeContent={alertsContextKey ? state[alertsContextKey] : 0}
          color='error'
        >
          {children}
        </Badge>
      </Link>
    );
  });
